"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateApiKeyLoginBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateApiKeyLoginBody = (0, validation_1.properties)({
    email: (0, validation_1.text)(),
    apiKey: (0, validation_1.text)(),
});
//# sourceMappingURL=ApiKeyLoginBody.js.map